export class DataTypeHelper {
    static GetDataTypes() {
        return [{ Caption: '@@Text', Value: 'System.String' }, { Caption: '@@Bool', Value: 'System.Boolean' }, { Caption: '@@Ganzzahl', Value: 'System.Int32' },
        { Caption: '@@Gleitzahl', Value: 'System.Double' }, { Caption: '@@Datum', Value: 'System.DateTime' }];
    }
}